'use client';

import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { isFilled } from '@prismicio/helpers';
import { PrismicNextImage } from '@prismicio/next';
import { RichText } from '@/app/lib/RichText';
import { ConditionalLink } from '@/app/lib/ConditionalLink';
import { formatLink, sliceStyle, dashify } from '@/app/lib/utils';
import styles from './venueCard.module.scss';

const VENUES_MAP_ID = 'venues-map';

export function VenueCard({ slice, venue, index, showScrollToMap = false }) {
	if (!isFilled.keyText(venue?.data?.name)) return null;

	const promoStyle = {
		...sliceStyle(slice?.primary),
		'--promo-text-color': slice?.primary?.text_color || '#000',
	};

	// const scrollToMap = () => {
	// 	document.getElementById(VENUES_MAP_ID)?.scrollIntoView({ behavior: 'smooth' });
	// };

	return (
		<div className={clsx(styles.wrapper)} style={sliceStyle(venue?.data, true)}>

			<div className={clsx(styles.details)} style={{ color: venue?.data?.text_color || '#000' }}>

				<div className={clsx(styles.top)} style={promoStyle}>
					<h2 className={clsx(styles.name)} style={{ color: venue?.data?.name_color || '#fff' }} id={dashify(venue?.data?.name)}>
						{venue?.data?.name}
					</h2>

					{/* {showScrollToMap && (
						<button type="button" className={clsx(styles.index)} onClick={scrollToMap} aria-label={`Scroll to map, venue ${index}`}>
							{index}
						</button>
					)} */}
				</div>

				<div className={clsx(styles.meta)}>

					{isFilled.richText(venue?.data?.address_line_1) && (
						<ConditionalLink
							url={venue?.data?.google_maps_link}
							condition={isFilled.link(venue?.data?.google_maps_link)}
							className={clsx(styles.address)}
						>
							<p>{venue?.data?.address_line_1}</p>
							{isFilled.richText(venue?.data?.address_line_2) && (<p>{venue?.data?.address_line_2}</p>)}
						</ConditionalLink>
					)}

					{isFilled.richText(venue?.data?.description) && (
						<div className={clsx(styles.description)}>
							<RichText field={venue?.data?.description} />
						</div>
					)}

					{isFilled.link(venue?.data?.more_info_url) && (
						<Link href={formatLink(venue?.data?.more_info_url)} className={styles.more}>
							{venue?.data?.more_info_url?.text || "Learn more"}
						</Link>
					)}
				</div>
			</div>

			{isFilled.image(venue?.data?.image) && (
				<div className={clsx(styles.image_wrapper)}>
					<PrismicNextImage field={venue?.data?.image} fallbackAlt='' className={styles.image} />
				</div>
			)}

		</div>
	);
}
